import styled from "styled-components";

export const Container = styled.div`
  span
  {
    background: #00A687;
    border-radius: 3px;
    display: block;
    height: 4px;
    margin-bottom: 5px;
    position: relative;
    width: 33px;
    z-index: 1;
  }

  @media (min-width: 767px) {
    display: none;
  }
`